export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";